import React from 'react'
import styles from "./TheSolution.module.css"
import HeaderBar from '../HeaderBar/HeaderBar'
import AnimatedButton from '../AnimatedButton/AnimatedButton';
import { useNavigate } from "react-router-dom";
const benefits = [
    "Answers calls automatically, 24/7",
    "Books appointments and captures leads",
    "No missed calls or hold times",
    "Costs a fraction of a full-time receptionist",
];
const TheSolution = () => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate("/recommended-plan");
    };
    return (
        <>
            <div className={styles.containerBox}>
                <div className={styles.Forsticky}>
                    <HeaderBar title="Your Solution" />
                </div>
                <div className={styles.container}>
                    <div className={styles.titleBar}>
                        <h4 className={styles.lightTitle}>A modern alternative</h4>
                        <h5 className={styles.BoldTitle}>for business calls</h5>
                    </div>
                    <div className={styles.divider}></div>
                    <div className={styles.benefitsBox}>
                        {benefits.map((item, index) => (
                            <div key={index} className={styles.item}>
                                <div className={styles.icon}>
                                    <img src='/svg/purpol_circle_checkBox.svg' alt='purpol_circle_checkBox' />
                                </div>
                                <p className={styles.text}>{item}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <AnimatedButton label='View Recommended Plan'   onClick={handleNavigate}/>
            </div>
        </>
    )
}

export default TheSolution
